<template>
  <section class="content">
    <admin-header
      title="GST-VAT"
      :uploader="true"
      disable-quick-search
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    />
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminQuoteTax',
    data () {
      return {
        newEntityScreen: 'Admin - Quote Taxes',
        searchEntityScreen: 'Admin - Quote Tax search',
        filterEventName: 'admin-quote-tax-filter',
        filterName: 'QuoteTaxFilter',
        entityName: 'quote-tax',
        transformFilterRequest: true
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminQuoteTax.vue?6e1fb9ae